import React, { useState, useEffect, useRef } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import moment from 'moment';
import { postJobTable } from 'nursd-dashboard/api/jobTable';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import { toast } from 'react-toastify';
// import FalconReactRange from 'components/doc-components/FalconReactRange';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { getOrderDetails, updateOrder } from 'nursd-dashboard/api/order';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getAllFacilityOrgList,
  getAllNurseOrgList
} from 'nursd-dashboard/api/organizationTable';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import Flex from 'components/common/Flex';

const Create_Order = () => {
  const searchInput = useRef(null);
  const { authToken } = useAuth();
  const navigate = useNavigate();

  const { orderId } = useParams();
  const type = 'Shift';
  // const [type, settType] = useState('Shift');
  const [managers, setManagers] = useState([]);
  const [nurseList, setNurses] = useState([]);
  // const [duration, setDuration] = useState([1]);
  const [valueLicense, setValueLicense] = useState(null);
  const [valueManager, setValueManager] = useState(null);
  const [orderDetails, setOrderDetails] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const animatedComponents = makeAnimated();

  const [formData, setFormData] = useState({
    shiftTitle: '',
    startDate: new Date(),
    endDate: new Date(),
    break: 'No Break',
    customerName: null,
    customerId: '',
    unit: '',
    floor: '',
    fullAddress: '',
    latitude: '',
    longitude: '',
    notes: '',
    jobType: type,
    jobTiming: '',
    customerVisibility: false,
    jobPostingTableFacilityTableId: '',
    jobPostingTableFacilityTableName: ''
  });

  function GetDateMergedTime(date, time) {
    const date1 = moment(date).format('YYYY-MM-DD');
    const time1 = moment(time).format('hh:mm a');
    const mergedTime = moment(`${date1} ${time1}`, `YYYY-MM-DD hh:mm a`);
    return mergedTime;
  }

  // function timeDifferentHour(sTime, eTime) {
  //   const startTime = moment(
  //     moment(new Date(sTime)).format('hh:mma'),
  //     'hh:mm A'
  //   );

  //   const start = moment(new Date(sTime));
  //   const end = moment(new Date(eTime));

  //   const endTime = moment(moment(new Date(eTime)).format('hh:mma'), 'hh:mm A');
  //   const endTimeEnd = moment(
  //     moment(new Date(eTime)).format('hh:mma'),
  //     'hh:mm A'
  //   ).add(1, 'day');

  //   const duration = moment.duration(endTime.diff(startTime));
  //   const durationEnd = moment.duration(endTimeEnd.diff(startTime));

  //   const hours = Math.floor(duration.asHours());
  //   const hoursEnd = Math.floor(durationEnd.asHours());

  //   const onlyHours = `${
  //     end.hour() <= 12 && start.hour() <= 12
  //       ? hours
  //       : end.hour() <= 12
  //       ? hoursEnd
  //       : hours
  //   }`;

  //   return onlyHours;
  // }

  function timeDifferent(sTime, eTime) {
    const startTime = moment(
      moment(new Date(sTime)).format('hh:mma'),
      'hh:mm A'
    );

    const start = moment(new Date(sTime));
    const end = moment(new Date(eTime));

    const endTime = moment(moment(new Date(eTime)).format('hh:mma'), 'hh:mm A');
    const endTimeEnd = moment(
      moment(new Date(eTime)).format('hh:mma'),
      'hh:mm A'
    ).add(1, 'day');

    const duration = moment.duration(endTime.diff(startTime));
    const durationEnd = moment.duration(endTimeEnd.diff(startTime));

    const hours = Math.floor(duration.asHours());
    const hoursEnd = Math.floor(durationEnd.asHours());
    const minutes = Math.floor(duration.asMinutes()) - hours * 60;

    // const onlyHours = `${
    //   end.hour() <= 12 && start.hour() <= 12
    //     ? hours
    //     : end.hour() <= 12
    //     ? hoursEnd
    //     : hours
    // } ${
    //   end.hour() <= 12 && start.hour() <= 12
    //     ? hours <= 1
    //       ? "hour"
    //       : "hours"
    //     : end.hour() <= 12
    //     ? hoursEnd <= 1
    //       ? "hour"
    //       : "hours"
    //     : hours <= 1
    //     ? "hour"
    //     : "hours"
    // }`;

    const onlyHours = `${
      end.hour() <= 12 && start.hour() <= 12
        ? hours
        : end.hour() <= 12
        ? hoursEnd
        : hours
    }${hours <= 1 ? 'hour' : 'hours'} ${
      minutes <= 0 ? '' : `${minutes}minutes`
    }`;

    return onlyHours;
  }

  const handleChange = ({ target }) => {
    let name = target.name;
    let value = name === 'customerVisibility' ? target.checked : target.value;
    setFormData({ ...formData, [name]: value });
  };

  const postJob = async () => {
    const ct = new Date(
      GetDateMergedTime(
        formData?.startDate,
        formData?.startDate?.toString()
      ).toString()
    );
    const currentHour = ct.getHours();
    let jobTiming =
      currentHour >= 5 && currentHour < 12
        ? 'Morning'
        : currentHour >= 12 && currentHour < 17
        ? 'Afternoon'
        : currentHour >= 17 && currentHour < 20
        ? 'Evening'
        : 'Night';

    await postJobTable(
      authToken,
      valueLicense?.map(i => i?.label),
      formData?.shiftTitle,
      '',
      [],
      '',
      '0',
      moment(formData?.startDate).format('YYYY-MM-DD'),
      moment(formData?.endDate).format('YYYY-MM-DD'),
      GetDateMergedTime(
        formData?.startDate,
        formData?.startDate?.toString()
      ).toString(),
      GetDateMergedTime(
        formData?.endDate,
        formData?.endDate?.toString()
      ).toString(),
      formData?.break,
      formData?.customerName,
      formData?.customerId?.toString(),
      formData?.unit,
      formData?.floor,
      formData?.fullAddress,
      formData?.latitude?.toString(),
      formData?.longitude?.toString(),
      '1',
      false,
      formData?.notes,
      type,
      'Open',
      '',
      '',
      [],
      false,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      timeDifferent(formData?.startDate, formData?.endDate),
      jobTiming,
      '',
      [],
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      false,
      false,
      false,
      false,
      false,
      formData.customerVisibility,
      '',
      '',
      {},
      '',
      formData.jobPostingTableFacilityTableId?.toString(),
      false,
      '',
      '',
      '',
      false,
      false,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      GetDateMergedTime(formData?.startDate, formData.startDate?.toString())
        .valueOf()
        .toString(),
      '',
      '',
      '',
      '',
      orderDetails?.organization,
      orderDetails?.location,
      orderId
    )
      .then(item => {
        let data = {
          ...orderDetails,
          status: 'Processed'
        };
        updateOrder(authToken, orderId, data, 'Processed');
        nurseList?.map(async item => {
          if (item?.mobileId) {
            sendNotification(authToken, {
              expoPushToken: item?.mobileId,
              title: 'New Job',
              body: `${type} available in your area.`,
              data: { screen: 'HomeScreen' }
            });
          }
        });
        toast.success(item?.shiftTitle + ' created successfully.', {
          theme: 'colored'
        });
        navigate(paths.nursd_order);
      })
      .catch(error => {
        console.log('data save error:', error);
      });
  };

  const handleSubmit = e => {
    e.preventDefault();
    postJob();
  };

  const licenseTypes = [
    { value: '1', label: 'LPN' },
    { value: '2', label: 'CNA' },
    { value: '3', label: 'RN' },
    { value: '4', label: 'HHA' }
  ];

  const getCustomer = async id => {
    try {
      await getOrderDetails(authToken, id).then(async res => {
        let d = res?.additionalFields[0];

        const dataList = await getAllFacilityOrgList(
          authToken,
          d?.location,
          d?.organization
        );

        const listManagers = dataList.sort((a, b) =>
          a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
        );
        let arrayManager = [];
        for (let i = 0; i < listManagers.length; i++) {
          const item = listManagers[i];
          let obj = {
            id: item.id,
            value: item.id,
            uniqueId: item.uniqueId,
            name: item.firstName + ' ' + item.lastName,
            label: item.firstName + ' ' + item.lastName,
            profileImage: item.profileImage,
            emailId: item.emailId,
            facilityLoginControl: item?.facilityLoginControl
          };
          arrayManager.push(obj);
        }
        if (listManagers.length === arrayManager.length) {
          setManagers(arrayManager);
        }

        const cusList = await getAllNurseOrgList(
          authToken,
          d?.location,
          d?.organization
        );

        const list = cusList.sort((a, b) =>
          a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
        );
        let array = [];
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          let obj = {
            id: item.id,
            uniqueId: item.uniqueId,
            name: item.firstName + ' ' + item.lastName,
            profileImage: item.profileImage,
            primaryLicenseType: item.primaryLicenseType,
            nurseLoginControl: item?.nurseLoginControl,
            nurseAppAccessControl: item.nurseAppAccessControl,
            original: item
          };
          array.push(obj);
        }
        if (list.length === array.length) {
          setNurses(array);
        }
        setOrderDetails(d);

        let arr = [];
        for (let i = 0; i < d?.licenseTypes.length; i++) {
          const item = d?.licenseTypes[i];
          let obj = { value: (i + 1).toString(), label: item };
          arr.push(obj);
        }
        if (d?.licenseTypes.length === arr.length) {
          setValueLicense(arr);
        }

        // timeDifferentHour(d?.startTime, d?.endTime)
        // setDuration([Number(timeDifferentHour(d?.startTime, d?.endTime))]);
        setFormData({
          ...formData,
          startDate: d?.startTime,
          endDate: d?.endTime,
          break: d?.break,
          fullAddress: d?.fullAddress,
          latitude: d?.latitude,
          longitude: d?.longitude,
          jobType: d?.jobType,
          customerVisibility: d?.customerVisibility,
          customerName: d?.customerName,
          customerId: d?.customerId
        });
        setLoading(false);
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (orderId !== '') {
      getCustomer(orderId);
    }
  }, [authToken, orderId]);

  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">
          Create Schedule -{' '}
          <Link to={paths.customer_profile(formData?.customerId)}>
            {formData?.customerName}
          </Link>
        </h5>
        {orderDetails && (
          <h5 className="fs-10 mt-3">Customer Note : {orderDetails?.notes}</h5>
        )}
      </Card.Header>
      {loading || managers.length === 0 ? (
        <h5 className="p-3">Loading...</h5>
      ) : (
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row className="mb-2">
              <Form.Group as={Col} md="6" className="mb-2" controlId="Manager">
                <Form.Label className="fs-9">Manager</Form.Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Select..."
                  isClearable
                  isSearchable
                  name="color"
                  value={valueManager}
                  onChange={value => {
                    setValueManager(value);
                    setFormData({
                      ...formData,
                      jobPostingTableFacilityTableName: value?.label,
                      jobPostingTableFacilityTableId: value?.id
                    });
                  }}
                  options={managers}
                  components={animatedComponents}
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md="6" className="mb-2" controlId="License">
                <Form.Label className="fs-9">License</Form.Label>
                <Select
                  closeMenuOnSelect={false}
                  options={licenseTypes}
                  placeholder="Select..."
                  isMulti
                  classNamePrefix="react-select"
                  value={valueLicense}
                  onChange={value => {
                    setValueLicense(value);
                  }}
                  components={animatedComponents}
                  required
                  isDisabled
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group
                as={Col}
                md="4"
                className="mb-2"
                controlId="shiftTitle"
              >
                <Form.Label className="fs-9">Title</Form.Label>
                <Form.Control
                  type="text"
                  name="shiftTitle"
                  placeholder="Title"
                  required
                  value={formData?.shiftTitle}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group
                as={Col}
                md="4"
                className="mb-2"
                controlId="startDate"
              >
                <Form.Label className="fs-9">Start</Form.Label>
                <DatePicker
                  selected={formData?.startDate}
                  onChange={date => {
                    setFormData({ ...formData, startDate: date });
                  }}
                  className="form-control"
                  placeholderText="MM-DD-YYYY H:M"
                  dateFormat="MM-dd-yyyy h:mm aa"
                  showTimeSelect
                  disabled
                />
              </Form.Group>
              <Form.Group as={Col} md="4" className="mb-2" controlId="Break">
                <Form.Label className="fs-9">Break</Form.Label>
                <Form.Select
                  name="className"
                  onChange={event => {
                    const value = event.target.value;
                    let date = new Date(formData.endDate);
                    let dateEnd = new Date(formData.endDate);
                    dateEnd.setFullYear(date.getFullYear());
                    dateEnd.setMonth(date.getMonth());
                    dateEnd.setDate(date.getDate());
                    dateEnd.setHours(
                      value === '1 Hour' ? date.getHours() + 1 : date.getHours()
                    );
                    dateEnd.setMinutes(
                      value === '15 Minutes'
                        ? date.getMinutes() + 15
                        : value === '30 Minutes'
                        ? date.getMinutes() + 30
                        : value === '45 Minutes'
                        ? date.getMinutes() + 45
                        : date.getMinutes()
                    );
                    setFormData({
                      ...formData,
                      break: value,
                      endDate: dateEnd
                    });
                  }}
                  value={formData?.break}
                  required
                  disabled
                >
                  <option value="No Break">No Break</option>
                  <option value="15 Minutes">15 Minutes</option>
                  <option value="30 Minutes">30 Minutes</option>
                  <option value="45 Minutes">45 Minutes</option>
                  <option value="1 Hour">1 Hour</option>
                </Form.Select>
              </Form.Group>
            </Row>
            {/* <Row>
              <Form.Group as={Col} md="12" className="mb-2" controlId="range">
                <Form.Label className="fs-9">Duration</Form.Label>
               <FalconReactRange
                  values={duration}
                  variant="primary"
                  step={1}
                  min={1}
                  max={12}
                  onChange={val => {
                    setDuration(val);
                    let date = new Date();
                    let dateEnd = new Date();
                    let newEnd = new Date(formData.startDate);
                    let selectedHourTime =
                      newEnd.getHours() === 0
                        ? 12
                        : newEnd.getHours() > 12
                        ? newEnd.getHours() - 12
                        : newEnd.getHours();
                    let selectedMinuteTime = newEnd
                      .getMinutes()
                      .toString()
                      .padStart(2, '0');
                    let selectedAPTime = newEnd.getHours() >= 12 ? 'PM' : 'AM';

                    date.setHours(
                      selectedAPTime === 'AM' && selectedHourTime === 12
                        ? 0
                        : selectedAPTime === 'PM' && selectedHourTime === 12
                        ? 12
                        : selectedHourTime !== 12 && selectedAPTime === 'PM'
                        ? parseInt(selectedHourTime) + 12
                        : parseInt(selectedHourTime)
                    );
                    date.setMinutes(selectedMinuteTime);
                    date.setFullYear(newEnd.getFullYear());
                    date.setMonth(newEnd.getMonth());
                    date.setDate(newEnd.getDate());

                    // Add 8 hours to dateEnd based on date
                    dateEnd.setFullYear(date.getFullYear());
                    dateEnd.setMonth(date.getMonth());
                    dateEnd.setDate(date.getDate());
                    dateEnd.setHours(date.getHours() + val[0]);
                    dateEnd.setMinutes(date.getMinutes());

                    // Determine if it's AM or PM
                    let meridiem = dateEnd.getHours() >= 12 ? 'PM' : 'AM';

                    if (selectedAPTime === 'PM' && meridiem === 'AM') {
                      // let endDate = moment(formData.startDate);
                      // endDate.add(1, 'day');
                      setFormData({
                        ...formData,
                        startDate: date,
                        endDate: dateEnd
                      });
                    } else {
                      setFormData({
                        ...formData,
                        startDate: date,
                        endDate: dateEnd
                      });
                    }
                  }}
                /> 
              </Form.Group>
            </Row> */}
            <Row className="mb-2">
              <Form.Group as={Col} md="6" className="mb-2" controlId="End">
                <Form.Label className="fs-9">End</Form.Label>
                <Form.Control
                  type="text"
                  name="End"
                  disabled
                  value={moment(formData?.endDate).format('MM-DD-YYYY hh:mm A')}
                />
              </Form.Group>
              <Form.Group
                as={Col}
                md="6"
                className="mb-2"
                controlId="FullAddress"
              >
                <Form.Label className="fs-9">Full Address</Form.Label>
                <Form.Control
                  required
                  ref={searchInput}
                  contentEditable={false}
                  type="text"
                  placeholder="Full Address"
                  value={formData?.fullAddress}
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group
                as={Col}
                md="4"
                className="mb-2 pt-4"
                controlId="customerVisibility"
              >
                <Form.Check
                  type="checkbox"
                  id="customerVisibility"
                  label="Customer Visible After Assignment"
                  name="customerVisibility"
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
            <Form.Group className="mb-2" controlId="notes">
              <Form.Label className="fs-9">Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="notes"
                onChange={handleChange}
              />
            </Form.Group>
            <Flex>
              <Button variant="primary" type="submit" className="px-4 mx-0">
                Publish
              </Button>
              <Button
                as={Link}
                to={paths.nursd_order}
                variant="secondary"
                className="mx-2"
              >
                Cancel
              </Button>
            </Flex>
          </Form>
        </Card.Body>
      )}
    </Card>
  );
};

export default Create_Order;
